import VASConnect from "../lib/vasconnect";

const vasConnectInstance = new VASConnect({
  appId: process.env.REACT_APP_VAS_APP_ID,
  licenseType: "persistent",
  licenseToken: process.env.REACT_APP_VAS_LICENSE_TOKEN,
  authorizeAutomatically: true,
});

//console.log("vasConnectInstance: ", vasConnectInstance);

export default vasConnectInstance;
